import { saveAs } from 'file-saver';

import { apiCallAsync } from 'src/redux/api/saga';
import { showNotification } from 'src/utils';
import { fetchSourceDocument } from './mockApi';
import { AiSourceReference } from './types';

// The backend contract for source documents is still open: this abstraction
// supports both an authenticated API blob (apiPath) and a direct URL. Until
// either is provided, references fall back to the mock document.
export async function downloadSourceReference(ref: AiSourceReference) {
  try {
    if (ref.apiPath) {
      const response = await apiCallAsync(ref.apiPath, {}, 'get', 'blob');
      saveAs(
        new Blob([response.data], {
          type: response.headers['content-type'],
        }),
        ref.filename,
      );
    } else if (ref.url) {
      saveAs(ref.url, ref.filename);
    } else {
      saveAs(await fetchSourceDocument(ref), ref.filename);
    }
  } catch (e) {
    showNotification('Unable to download the source document', 'error');
    console.error(e);
  }
}
